{
  "chart": {
    "empty": {
      "description": "Brak danych z tego okresu.",
      "title": "Nie znaleziono danych"
    }
  },
  "date_picker": {
    "all_time": "Cały okres",
    "confirm": "Potwierdź",
    "current_quarter": "Bieżący kwartał",
    "date_range": "Zakres dat od {startDate} – do {endDate}",
    "last_n_days": "Ostatnie {days} dni",
    "last_n_months": "Ostatnie {months} miesiące",
    "last_quarter": "Poprzedni kwartał",
    "last_year": "Poprzedni rok",
    "lifetime": "Cały okres",
    "this_year": "Ten rok",
    "today": "Dziś"
  },
  "document_viewer": {
    "sidebar_heading": "Przegląd treści"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Wprowadź treść",
    "placeholder_with_options": "Wprowadź treść lub wpisz „/”, aby zobaczyć opcje"
  },
  "error": {
    "title": "Wystąpił błąd."
  },
  "factor_indicator": {
    "average": "Średni",
    "bad": "Słaby",
    "excellent": "Doskonały",
    "good": "Dobry"
  },
  "gauge_chart": {
    "empty": {
      "title": "Brak dostępnych danych",
      "tooltip": "Wynik bezpieczeństwa jest obliczany"
    }
  },
  "locale": {
    "current": "Polski",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Kontynuuj z {provider}"
  },
  "search": {
    "no_options": "Brak opcji.",
    "no_results": "Brak wyników.",
    "placeholder": "Szukaj..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Zamknij podgląd",
      "open": "Rozwiń podgląd"
    }
  },
  "video_player": {
    "captions": "Napisy",
    "captions_off": "Wyłączone",
    "normal_speed": "Normalna",
    "playback_speed": "Szybkość odtwarzania"
  }
}
